// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Draw_cardWrapper__CaE0H","noDrawsMessage":"Draw_noDrawsMessage__rnVp9"};